import { ROUTES } from './routes'

export interface QuickActionDef {
  key: string
  icon: string
  label: string
  route: string
  required?: boolean
}

export const ALL_QUICK_ACTIONS: QuickActionDef[] = [
  { key: 'mission',  icon: 'fa-tower-broadcast',        label: 'Mission',       route: ROUTES.MISSION_CONTROL },
  { key: 'sos',      icon: 'fa-triangle-exclamation',   label: 'SOS',           route: ROUTES.SOS, required: true },
  { key: 'location', icon: 'fa-location-dot',           label: 'Location',      route: ROUTES.LOCATION },
  { key: 'hazards',  icon: 'fa-triangle-exclamation',   label: 'Hazard Watch',  route: ROUTES.HAZARDS },
  { key: 'weather',  icon: 'fa-cloud-sun',              label: 'Weather',       route: ROUTES.WEATHER },
  { key: 'qr',       icon: 'fa-qrcode',                 label: 'QR',            route: ROUTES.QR },
  { key: 'profiles', icon: 'fa-id-card',                label: 'Profiles',      route: ROUTES.PROFILES },
  { key: 'sessions', icon: 'fa-clipboard',              label: 'Sessions',      route: ROUTES.SESSIONS },
  { key: 'community',icon: 'fa-users',                  label: 'Community',     route: ROUTES.COMMUNITY },
  { key: 'findhelp', icon: 'fa-hands-holding-heart',    label: 'Find Help',     route: ROUTES.FIND_HELP },
]

export const DEFAULT_QUICK_ACTION_KEYS = ['mission', 'sessions', 'hazards', 'weather', 'findhelp', 'community']
export const MAX_QUICK_ACTIONS = 6
